<template>
  <div
    class="trainer-error gw_mesblock_container"
    style="--message-padding: 2rem"
  >
    <div
      v-if="messages.includes('204')"
      class="gw_mesblock"
    >
      <div class="gw_mesblock_code">204</div>
      <div
        class="gw_mesblock_title"
        v-html="$t(`messages.practice.title_204`)"
      />
      <div
        class="gw_mesblock_subtitle pt-1"
        v-html="$t(`messages.practice.subtitle_204`)"
      />
      <!-- <div
        class="mt-4 pt-2 bt-grey bt-current-color text-small text-center"
        style="max-width: 420px; padding: 0 1rem; color: var(--clr-yellow)"
        v-html="
          'Some solutions are currently not available due to maintenance. We’re working to get things back to normal as quickly as possible.'
        "
      /> -->
    </div>
    <div
      v-if="messages.includes('204_elite')"
      class="gw_mesblock"
    >
      <div class="gw_mesblock_code">204_elite</div>
      <div
        class="gw_mesblock_title"
        v-html="$t(`messages.practice.title_204_elite`)"
      />
      <div
        class="gw_mesblock_subtitle pt-1"
        v-html="$t(`messages.practice.subtitle_204_elite`)"
      />
      <!-- <div
        class="mt-4 pt-2 bt-grey bt-current-color text-small text-center"
        style="max-width: 420px; padding: 0 1rem; color: var(--clr-yellow)"
        v-html="
          'Some solutions are currently not available due to maintenance. We’re working to get things back to normal as quickly as possible.'
        "
      /> -->
    </div>
    <div
      v-if="
        [
          '403_elite_preflop', //
          '403_elite_flop',
          '403_elite_rake_preflop',
          '403_elite_rake_flop',
          '403_elite_icm',
        ].some(i => messages.includes(i))
      "
      class="gw_mesblock"
    >
      <div class="gw_mesblock_code">403_elite</div>
      <div
        class="gw_mesblock_title weight_700"
        v-html="getCussolMessage(messages[0])"
      ></div>

      <router-link
        class="gw_btn gw_btn-v1 gw_btn_primary w-100 weight_500 mt-4 clr-white"
        style="--padding: 1.5rem; font-size: 1rem"
        :to="{
          name: 'SubscriptionOverview',
          query: { gm_type: messages.includes('403_elite_icm') ? 'mtt' : 'cash' },
        }"
      >
        <i class="mdi text-large mdi-crown mr-2"></i>
        {{ $t('btn.upgrade') }}
      </router-link>

      <div
        v-if="
          [
            '403_elite_flop', //
            '403_elite_rake_flop',
            '403_elite_icm',
          ].some(i => messages.includes(i))
        "
        class="d-flex f-column bt-grey mt-2 w-100 mx-auto"
        style="gap: 0.5rem"
      >
        <div
          class="gw_btn-v1 w-100 clr-white f-column"
          style="font-size: 1rem; --padding: 1.5rem; --brighten-active: 0.05"
          @click="switchToFreeEliteBoard()"
        >
          <div class="f-center">
            Try free flop
            <CardRowSimple
              class="ml-2"
              :board="'QsTs7h'"
              style="--crds-card-height: 1.875rem; --crds-card-value-size-increase: 0.9"
            >
            </CardRowSimple>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="messages.includes('403_starter')"
      class="gw_mesblock"
    >
      <div class="gw_mesblock_code">403_starter</div>
      <div
        class="gw_mesblock_title"
        v-html="$t(`messages.practice.title_starter_403`)"
      />
      <div
        class="gw_mesblock_subtitle"
        v-html="
          $t(`messages.practice.subtitle_429_tra01`, {
            gameformat: gameformatTra,
            gameformat_option: gameformatOptionHtml,
            gameformat_tiers: unpurchasedGameformatTiersTra,
          })
        "
      />
      <v-btn
        color="primary"
        class="mt-2"
        :to="{
          name: 'SubscriptionOverview',
          query: { gm_type: gameformat.gm_type },
        }"
        :data-tst="`${tstPrefix}_403_starter_upgrade_btn`"
      >
        <i class="mdi mdi-crown mr-2 text-semi-large"></i>
        {{ $t('btn.upgrade') }}</v-btn
      >
    </div>
    <div
      v-if="messages.includes('403_only_subscribed')"
      class="gw_mesblock"
    >
      <div class="gw_mesblock_code">403_only_subscribed</div>
      <div
        class="gw_mesblock_title"
        v-html="$t(`messages.practice.title_only_subscribed_403`)"
      />
      <v-btn
        color="primary"
        class="mt-2"
        :to="{
          name: 'SubscriptionOverview',
          query: { gm_type: gameformat.gm_type },
        }"
        :data-tst="`${tstPrefix}_403_only_subscribed_upgrade_btn`"
      >
        <i class="mdi mdi-crown mr-2 text-semi-large"></i>
        {{ $t('btn.upgrade') }}</v-btn
      >
    </div>
    <div
      v-if="messages.includes('429_starter')"
      class="gw_mesblock"
    >
      <div class="gw_mesblock_code">429_starter</div>
      <div
        class="gw_mesblock_title"
        v-html="$t(`messages.practice.title_429`)"
      />
      <div
        class="gw_mesblock_subtitle"
        v-html="
          $t(`messages.practice.subtitle_429_tra01`, {
            gameformat: gameformatTra,
            gameformat_option: gameformatOptionHtml,
            gameformat_tiers: unpurchasedGameformatTiersTra,
          })
        "
      />
      <v-btn
        color="primary"
        class="mt-2"
        :to="{
          name: 'SubscriptionOverview',
          query: { gm_type: gameformat.gm_type },
        }"
        :data-tst="`${tstPrefix}_429_starter_upgrade_btn`"
      >
        <i class="mdi mdi-crown mr-2 text-semi-large"></i>
        {{ $t('btn.upgrade') }}</v-btn
      >
    </div>
    <div
      v-if="messages.includes('429')"
      class="gw_mesblock"
    >
      <div class="gw_mesblock_code">429</div>
      <div
        class="gw_mesblock_title"
        v-html="$t(`messages.practice.title_429`)"
      />
      <div
        class="gw_mesblock_subtitle"
        v-html="
          $t(`messages.practice.subtitle_429_tra01`, {
            gameformat: gameformatTra,
            gameformat_option: gameformatOptionHtml,
            gameformat_tiers: unpurchasedGameformatTiersTra,
          })
        "
      />

      <div
        v-if="gmfAvailableDepths && starterPurchasedForCurrentGametypeGroup"
        class="starter-available-depths gw_mesblock_subtitle_small bt-grey text-center mt-2 pt-2"
        v-html="
          gmfAvailableDepths.customMessage
            ? $t(`messages.practice.subtitle_403_starter_depths_custom`, {
                str: gmfAvailableDepths.customMessage,
                gameformat: gameformatTra,
              })
            : $t(`messages.practice.subtitle_403_starter_depths`, {
                depths: gmfAvailableDepths.stacks,
                gameformat: gameformatTra,
              })
        "
      />

      <v-btn
        color="primary"
        class="mt-2"
        :to="{
          name: 'SubscriptionOverview',
          query: { gm_type: gameformat.gm_type },
        }"
        :data-tst="`${tstPrefix}_429_upgrade_btn`"
      >
        <i class="mdi mdi-crown mr-2 text-semi-large"></i>
        {{ $t('btn.upgrade') }}</v-btn
      >
    </div>
    <div
      v-if="messages.includes('400_TREE_IS_TOO_BIG')"
      class="gw_mesblock"
      style="min-width: clamp(1px, 36rem, 100vw)"
    >
      <div class="gw_mesblock_code">400_TREE_IS_TOO_BIG</div>
      <div
        class="gw_mesblock_title"
        v-html="$t(`messages.practice.title_400_TREE_IS_TOO_BIG`)"
      />
      <div
        class="gw_mesblock_subtitle"
        v-html="$t(`messages.practice.subtitle_400_TREE_IS_TOO_BIG`)"
      />

      <div
        class="gw_btn-v1"
        style="
          font-size: var(--btn-font-size);
          margin: var(--btn-margin);
          --clr-back: var(--clr-blue-1);
        "
        @click="openCustomSolutionsDialog()"
      >
        <i class="text-normal-large mdi mdi-pencil mr-1"></i>
        {{ $t('btn.edit_solution') }}
      </div>

      <div class="clr-grey text-center pt-4 bt-grey f-center f-column mt-4">
        <span
          style="max-width: 22rem"
          v-html="$t('messages.if_problem_contact_us_with_url')"
        >
        </span>
        <GwBtnClipboard
          class="flex-1 mt-2"
          copyUrl
        />
      </div>
    </div>
    <div
      v-if="messages.includes('400_INVALID_HAND')"
      class="gw_mesblock"
    >
      <div class="gw_mesblock_code">400_INVALID_HAND</div>
      <div
        class="gw_mesblock_title"
        v-html="$t(`messages.practice.title_400_INVALID_HAND`)"
      />
      <div
        class="gw_mesblock_subtitle"
        v-html="$t(`messages.practice.subtitle_400_INVALID_HAND`)"
      />
    </div>
    <div
      v-if="messages.includes('400_INVALID_SESSION')"
      class="gw_mesblock"
    >
      <div class="gw_mesblock_code">400_INVALID_SESSION</div>
      <div
        class="gw_mesblock_title"
        v-html="$t(`messages.practice.title_400_INVALID_SESSION`)"
      />
      <div
        class="gw_mesblock_subtitle"
        v-html="$t(`messages.practice.subtitle_400_INVALID_SESSION`)"
      />
    </div>
    <div
      v-if="messages.includes('unhandled')"
      class="gw_mesblock"
    >
      <div class="gw_mesblock_code">unhandled</div>
      <div
        class="gw_mesblock_title"
        v-html="$t(`messages.oops_error`)"
      />
      <div
        class="gw_mesblock_subtitle"
        v-html="$t(`messages.practice.trainer_continue_to_next_hand`)"
      />

      <div class="clr-grey pt-4 text-center bt-grey f-center f-column mt-4">
        <span
          style="max-width: 22rem"
          v-html="$t('messages.if_problem_contact_us_with_url')"
        >
        </span>
        <GwBtnClipboard
          class="flex-1 mt-2"
          copyUrl
        />
      </div>

      <div class="text-smallest clr-grey d-flex mt-4">
        <div
          class="mr-1"
          v-html="usingCustomTree ? 'custom-solution' : gameformat.gametype"
        ></div>
        <div class="uppercase">/ {{ handler }} / {{ status }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import GwBtnClipboard from '@/components/lib/GwBtnClipboard/GwBtnClipboard'
import CardRowSimple from '@/components/CardRow/CardRowSimple'
import tier_mix from '@/mixins/tier_mix'
import format_mix from '@/mixins/format_mix'
import { getGameformatOptionHtml } from '@/store/gameformat/gameformat'
import { SNK } from '@/helpers/helpers'

export default {
  name: 'MessagesTrainerError',
  components: {
    GwBtnClipboard,
    CardRowSimple,
  },
  mixins: [format_mix, tier_mix],
  props: {
    namespace: { String, required: true },
    item: Object,
    tstPrefix: { default: 'trainer_table_0' },
  },
  methods: {
    switchToFreeEliteBoard() {
      this.$store.dispatch(`hands_stop`)
      this.$store.dispatch(`tra/alpha/router_update_query`, {
        query: { board: 'QsTs7h' },
      })
    },
    openCustomSolutionsDialog() {
      this.$store.dispatch(`hands_stop`)
      const tmpNamespace = 'tmp/primary'
      const dialog = `solfigr-create-custom-solution-dialog_namespace-${tmpNamespace}_mode-keepboard`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
    // TODO unify with StudyMessageOverlay
    getCussolMessage() {
      return (
        {
          '403_elite_preflop': this.$t(`messages.upgrade_to_elite_unlock_custom_preflop_solutions`),
          '403_elite_flop': this.$t(`messages.upgrade_to_elite_unlock_custom_solutions`),
          '403_elite_rake_flop': this.$t(
            `messages.upgrade_to_elite_unlock_custom_solutions_with_rake`,
            { tier: 'Cash, Straddle Ante Cash' },
          ),
          '403_elite_rake_preflop': this.$t(
            `messages.upgrade_to_elite_unlock_custom_solutions_with_rake`,
            { tier: 'Cash or Straddle Ante Cash' },
          ),
          '403_elite_icm': this.$t(`messages.upgrade_to_elite_unlock_all_flops_with_icm`, {
            tier: 'MTT',
          }),
        }[this.messages[0]] || this.$t(`messages.upgrade_to_elite_unlock_custom_solutions`)
      )
    },
  },
  computed: {
    starterPurchasedForCurrentGametypeGroup() {
      const { gameformats } = this.$store.getters
      const res = gameformats.some(
        i => i.group === this.gameformat?.group && i.subscription_tier === 'STARTER',
      )
      return res
    },
    gmfAvailableDepths() {
      const gmf = this.gameformat
      if (gmf?.group === 'cash') {
        return { stacks: '100' }
      }
      if (gmf?.group === 'mtt') {
        return { stacks: '14, 25, 35, 60, 80' }
      }
      if (gmf?.group === 'spins') {
        return { customMessage: 'Symmetric solutions (all players have the same stacks)' }
      }
      if (gmf?.group === 'husng') {
        return { stacks: '25, 20, 18, 15, 12, 10, 8, 6, 5, 4, 3, 2, 1' }
      }
      return null
    },
    messages() {
      const { status, handler, gameformatStarter, solElite } = this
      // console.log('solElite', { status, gameformatStarter, solElite })
      let res = []
      if (status === 204 && solElite.want_use) {
        res.push('204_elite')
      } else if (status === 204) {
        res.push('204')
      } else if (status === 403 && solElite.want_use) {
        const withoutICM = solElite.is_elite_without_icm
        const withoutRake = solElite.is_elite_without_rake
        res.push(
          withoutICM
            ? '403_elite_icm'
            : solElite.is_preflop
              ? withoutRake
                ? '403_elite_rake_preflop'
                : '403_elite_preflop'
              : withoutRake
                ? '403_elite_rake_flop'
                : '403_elite_flop',
        )
      } else if (status === 403 && gameformatStarter) {
        res.push('403_starter')
      } else if (status === 403) {
        res.push('403_only_subscribed')
      } else if (status === 429 && gameformatStarter) {
        res.push('429_starter')
      } else if (status === 429) {
        res.push('429')
      } else if (status === 400 && this.code === 'TREE_IS_TOO_BIG') {
        res.push('400_TREE_IS_TOO_BIG')
      } else if (status === 400 && this.code === 'INVALID_HAND') {
        res.push('400_INVALID_HAND')
      } else if (status === 400 && this.code === 'INVALID_SESSION') {
        res.push('400_INVALID_SESSION')
      } else {
        if (status !== 401) {
          // if (status !== 500 && status !== 401) {
          // Sentry CaptureConsole
          if (status !== 0 && status !== 500 && status !== 503) {
            // timeouts are ignored cos when server fails then sentry is full
            const errData = this.item?.result?.error?.response?.data
            const strErr = typeof errData === 'string' ? '' : JSON.stringify(errData)
            console.error(`error-trainer-${status}-${handler}`, strErr)
          }
        }
        res.push('unhandled')
      }
      // res = [
      // '204',
      // '204_elite',
      // '403_elite'
      // '403_starter',
      // '403_only_subscribed',
      // '429_starter',
      // '429',
      // '400_TREE_IS_TOO_BIG',
      // '400_INVALID_HAND',
      // '400_INVALID_SESSION',
      // 'unhandled',
      // ]
      // console.log(res)
      return res
    },
    result() {
      // console.log('--ERROR', this.item)
      return this.item?.result
    },
    usingCustomTree() {
      return this.item?.result?.callParams?.params?.custom_tree_id
    },
    response() {
      const errorResponse = this.result?.error?.response
      const okResponse = this.result?.response
      const res = errorResponse || okResponse
      return res
    },
    code() {
      return this.response?.data?.code
    },
    handler() {
      // return this.item?.gamestate_handler
      return this.item?.handler
    },
    status() {
      return this.response?.status || this.result?.error?.request?.status
    },
    gameformat() {
      return this.$store.getters[SNK('gameformat', this.namespace)]
    },
    solElite() {
      return this.$store.getters[SNK('sol_elite', this.namespace)]
    },
    gameformatOptionHtml() {
      return getGameformatOptionHtml({ gameformat: this.gameformat })
    },
    gameformatTra() {
      // if (this.tm_accessInPremiumSubOnly) {
      //   return this.$t(`gametypes.groups.${'straddle_ante_cash'}_long`)
      // }
      return this.$t(`gametypes.groups.${this.gameformat.group}_long`)
    },
    unpurchasedGameformatTiersTra() {
      const res = `${
        this.gameformatAny || this.gameformatTrial
          ? `${this.$t(`tier.options.starter`)} / ${this.$t(`tier.options.premium`)}`
          : this.$t(`tier.options.premium`)
      }`
      return res
    },
  },
}
</script>
